export default container => {
  const buttons = container.querySelectorAll('[data-button]')

  const observer = new IntersectionObserver(entries => {
    entries.forEach(
      entry => {
        if (entry.isIntersecting) {
          buttons.forEach(button => {
            button.style.visibility = 'visible'
            button.classList.remove('button-mini__container--hide')
            button.classList.add('button-mini__container--show')
          })
        }
      },
      { rootMargin: '0 0 -500px' }
    )
  })

  container.querySelectorAll('[data-show-button]').forEach(section => {
    observer.observe(section)
  })
}
